export interface IAddressItem {
  address?: string | null;
  city?: string | null;
  cityPart?: string | null;
  street?: string | null;
  postal_code?: string | null;
  houseNumber?: number | null;
  orientationNumber?: number | null;
}

/**
 * get address from RUIAN data
 * ulice(cast obce) cp/cor
 */
export const getAddress = ({
  street = '',
  city = '',
  houseNumber = NaN,
  cityPart = '',
  orientationNumber = NaN,
}: IAddressItem): string => {
  const number = `${houseNumber || ''}${orientationNumber && houseNumber ? '/' : ''}${
    orientationNumber || ''
  }`;

  const address = `${street || cityPart || city}`;

  return `${address || ''}${number && address ? ' ' : ''}${number || ''}`;
};

/**
 * get city from RUIAN data
 * obec (- cast obce pokud neni ulice)
 */
export const getCity = ({ street = '', city = '', cityPart = '' }: IAddressItem): string => {
  if (street) {
    return `${city}${cityPart && cityPart !== city ? ` - ${cityPart}` : ''}`;
  }

  return city || '';
};
